import { render, staticRenderFns } from "./TheHeaderDropdownAccount.vue?vue&type=template&id=70dd78fb&scoped=true&"
import script from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownAccount.vue?vue&type=style&index=0&id=70dd78fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd78fb",
  null
  
)

export default component.exports